<template>
  <div class="h-full flex items-center pt-2">
    <DateInput
      v-model="currentValue"
      :placeholder="$t('common.from-date')"
      :clearable="true"
      :compact="true"
      value-type="YYYY-MM-DD"
      format="DD.MM.YYYY"
      class="w-full"
      @input="onDateChanged"
    />
  </div>
</template>

<script>
import { DateInput } from '@/components/Inputs';

export default {
  components: { DateInput },
  data: function () {
    return {
      currentValue: null,
    };
  },
  beforeMount() {
    const filterModel =
      this.params.api?.getFilterModel()[this.params.column.colId];
    if (filterModel && filterModel.filter) {
      this.currentValue = filterModel.filter.split('T')[0];
    }
  },
  methods: {
    onDateChanged() {
      if (this.params.api) {
        let filterValue = null;

        if (this.currentValue) {
          filterValue = `${this.currentValue}T00:00:00.000Z`;
        }

        const newFilterModel = {
          ...this.params.api.getFilterModel(),
          [this.params.column.colId]: filterValue
            ? {
                filterType: 'date',
                type: 'greaterThanOrEqual',
                filter: filterValue,
              }
            : null,
        };

        this.params.api.setFilterModel(newFilterModel);

        this.params.api.dispatchEvent({
          type: 'filterChanged',
          api: this.params.api,
          columnApi: this.params.columnApi,
        });
      }
    },

    onFloatingFilterChanged(change) {
      this.currentValue = change;
    },
  },
};
</script>
